/**
 * MAP.TYPE
 * Map for the establisment (in order to pin into on them)
 */
import { v4 as uuid } from "uuid"

export const MAP_ENTITY = "map"

export interface MapOverviewPoint {
  x: number
  y: number
}

export interface MapOverviewArea {
  p1: MapOverviewPoint
  p2: MapOverviewPoint
  p3: MapOverviewPoint
  p4: MapOverviewPoint
}

export interface Map {
  id: string
  name: string
  order: number
  sitesOrder: string[]
  EstablishmentId: string
  overviewArea: MapOverviewArea | null
}

export const createEmptyMap = (overrides?: Partial<Map>): Map => {
  const defaultMap: Map = {
    id: uuid(),
    name: "",
    order: 0,
    sitesOrder: [],
    EstablishmentId: "",
    overviewArea: null
  }

  return {
    ...defaultMap,
    ...overrides
  }
}
